// import { useMemo, useState, useRef, useEffect, useCallback } from "react";

import {
  Box,
  HStack,
  Heading,
  CircularProgress,
  Container,
  Breadcrumb,
  BreadcrumbItem,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";

// import { useHistory } from "react-router-dom";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import { CustomTab } from "../Cards/MyCard";

// import Button from "components/Button/Button";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import NewPanel from "./Panels/New";
import HistoryPanel from "./Panels/History";

export default function Swap(props) {
  const { logout } = props;

  const isLoading = false;

  return (
    <Box>
      <Sidemenu currentPage="Exchange" logoutUser={logout} />
      <Header />

      <Box className="swap">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={["100%", "100%", "calc(100% - 20vw)", "calc(100% - 35vw)"]}
            m="0"
            p="0"
          >
            <Box px={["24px", "0", "0"]}>
              <HStack>
                <Heading fontSize="3xl">Swap</Heading>
                {isLoading && (
                  <CircularProgress
                    ml="20px !important"
                    isIndeterminate
                    color="var(--primary)"
                    size="20px"
                  />
                )}
              </HStack>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/home">Home</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage to="/dashboard/swap">
                    Swap
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <Box
              bg="white"
              border="1px solid #8688942f"
              // minH="681px"
              //   w="calc(100% - 25vw)"
              w="100%"
              mt="32px"
              borderRadius="8px"
              p={["28px"]}
            >
              <Tabs isFitted>
                <TabList border="none" borderRadius="6px" p="6px" bg="#D9DBE9">
                  <CustomTab>New</CustomTab>
                  <CustomTab>History</CustomTab>
                </TabList>

                <TabPanels>
                  <TabPanel px="0">
                    <NewPanel {...props} />
                  </TabPanel>
                  <TabPanel px="0">
                    <HistoryPanel {...props} />
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Box>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}
